import React, { FC, useLayoutEffect, useState, useRef, ReactNode } from 'react';
import './DoubleScrollbar.scss';

/**
 * Renders additional horizontal scrollbar on top of the children container.
 */
export const DoubleScrollbar: FC<{ children: ReactNode }> = props => {
  const [width, setWidth] = useState<number>(0);
  const childrenContainer = useRef<HTMLDivElement>(null);
  const scrollContainer = useRef<HTMLDivElement>(null);
  const scrollBar = useRef(null);

  useLayoutEffect(() => {
    const scrollContainerEl = scrollContainer.current;
    const childEl = childrenContainer.current?.children?.[0];

    const calcWidth = () => {
      // subtract 1 to avoid problem with fractional pixels
      setWidth((childEl?.scrollWidth ?? 0) - 1);
    };

    // set initial value
    calcWidth();

    // update on resize
    window.addEventListener('resize', calcWidth);

    // map scroll events
    if (scrollContainerEl && childEl) {
      scrollContainerEl.onscroll = () => {
        childEl.scrollLeft = scrollContainerEl.scrollLeft;
      };
      (childEl as HTMLElement).onscroll = () => {
        scrollContainerEl.scrollLeft = childEl.scrollLeft;
      };
    }
    return () => {
      window.removeEventListener('resize', calcWidth);
    };
  }, [scrollContainer, childrenContainer, props.children]);

  return (
    <div>
      <div
        ref={scrollContainer}
        className="double-scroll-container"
        style={{
          // hide scroll bar when child is not wide enough
          height:
            width >= (childrenContainer.current?.offsetWidth ?? 0)
              ? '18px'
              : '0px',
          marginBottom: '8px',
        }}
      >
        <div ref={scrollBar} style={{ width }}>
          &nbsp;
        </div>
      </div>
      <div ref={childrenContainer} className="double-scroll-children">
        {props.children}
      </div>
    </div>
  );
};

export default DoubleScrollbar;
